import { TAG } from "../constants";
import { EPrescribePharmacy } from "../types";
import { patientApi } from "./patientApi";

export const ePrescribeApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    searchNearbyPharmacies: builder.query<
      EPrescribePharmacy[],
      void | { name?: string }
    >({
      query: (name) => ({
        method: "GET",
        url: `/api/patient/e-prescribe/pharmacies/search`,
        params: {
          name: name ?? undefined,
        },
      }),
      providesTags: [TAG.PHARMACY_SEARCH],
    }),
  }),
});

export const { useSearchNearbyPharmaciesQuery } = ePrescribeApi;
